import styled, { css } from 'styled-components/macro';

const BaseModal = css`
  p {
    line-height: 1.8rem;
  }
  a {
    ${props => props.theme.fontStackHeader};
  }
  @media screen and (min-width: 1024px) {
    p {
      line-height: 2.1rem;
    }
  }
`;

// ConfirmationModal
export const ConfirmationModalDiv = styled.div`
  ${BaseModal}
  width: 300px;
  max-width: 90vw;
`;
export const ConfirmationModalContentDiv = styled.div`
  padding: 5rem 3rem 4rem;
  text-align: center;
  h4 {
    margin-bottom: 1rem;
  }
`;
export const ConfirmationModalButtons = styled.div``;
export const ConfirmationModalA = styled.a`
  display: inline-block;
  position: relative;
  padding: 25px 0;
  border: 1px solid transparent;
  border-top-color: ${props => props.theme.mercury};
  text-transform: uppercase;
  ${props => props.theme.fontStackHeader};
  text-align: center;
  font-weight: 600;
  font-size: 1.3rem;
  cursor: pointer;
  &:first-child {
    width: calc(50% + 1px);
    color: ${props => props.theme.blue};
    border-right-color: ${props => props.theme.mercury};
  }
  &:last-child {
    width: 50%;
    color: ${props => props.theme.dustyGray};
    border-left-color: ${props => props.theme.mercury};
    margin-left: -1px;
  }
  &:hover {
    border-color: ${props => props.theme.blue};
    color: ${props => props.theme.blue};
    z-index: 1;
  }
`;
export const SuccessModalA = styled.a`
  display: inline-block;
  position: relative;
  padding: 25px 0;
  border: 1px solid transparent;
  border-top-color: ${props => props.theme.mercury};
  text-transform: uppercase;
  ${props => props.theme.fontStackHeader};
  text-align: center;
  font-weight: 600;
  font-size: 1.3rem;
  cursor: pointer;
  &:first-child {
    /* width: calc(50% + 1px); */
    width: 100%;
    color: ${props => props.theme.blue};
    border-right-color: ${props => props.theme.mercury};
  }
  /* &:last-child {
    width: 50%;
    color: ${props => props.theme.dustyGray};
    border-left-color: ${props => props.theme.mercury};
    margin-left: -1px;
  } */
  &:hover {
    border-color: ${props => props.theme.blue};
    color: ${props => props.theme.blue};
    z-index: 1;
  }
`;

// ErrorModal
export const ErrorModalDiv = styled.div`
  width: 250px;
  max-width: 90vw;
  svg {
    width: 2.2rem;
    height: 2.2rem;
    margin-bottom: 1rem;
    fill: ${props => props.theme.red};
  }
`;
